import { render, staticRenderFns } from "./QualityCourseCreate.vue?vue&type=template&id=5d8acb52&scoped=true"
import script from "./qualityCouresCreate.js?vue&type=script&lang=js&external"
export * from "./qualityCouresCreate.js?vue&type=script&lang=js&external"
import style0 from "./QualityCourseCreate.vue?vue&type=style&index=0&id=5d8acb52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8acb52",
  null
  
)

export default component.exports